<template>
  <div>
    <el-form-item label="驳回原因">
      <el-input v-model="reason"
                placeholder="驳回时请填写，通过无需填写"></el-input>
    </el-form-item>
    <div class="buttons">
      <el-button type="primary"
                 @click="financeApprove">{{showSplitButton ? '财务审批 通过(手动)' : '财务审批 通过'}}
      </el-button>
      <el-button v-if="showSplitButton" type="success"
                 @click="financeAutoApprove">财务审批 通过(自动)
      </el-button>
      <el-button type="danger"
                 @click="approveFail">财务审批 驳回
      </el-button>
    </div>
    <InvoiceTicketSplit v-if="showSplitView"
                        :dataSource="data.detail"
                        :invoice-tax-type="data.invoice_tax_type"
                        @onSave="handleTicketSplit"
                        @onClose="showSplitView = false"/>
  </div>
</template>

<script>
import InvoiceTicketSplit from '../ticket-split/InvoiceTicketSplit'

export default {
  components: {
    InvoiceTicketSplit,
  },
  props: {
    id: {
      type: Number,
      default: -1,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showSplitButton () {
      // 自动开票功能已废弃
      return false
    }
  },
  data () {
    return {
      reason: '',
      showSplitView: false,
    }
  },
  methods: {
    // 通过
    financeApprove () {
      this.$confirm('即将通过本开票申请，是否确认？', '通过开票申请确认').then(() => {
        request.common('financeApprovePassReceiptApply', {id: this.$route.params.id}).then((res) => {
          this.$router.push('/invoice-apply/approve/table')
        })
      })
    },
    // 驳回
    approveFail () {
      if (this.reason) {
        let reason = this.reason
        this.$confirm('即将驳回本开票申请，是否确认？', '驳回开票申请确认', {type: 'warning'}).then(() => {
          request.common('financeApproveRejectReceiptApply', {id: this.$route.params.id, reason: reason}).then((res) => {
            this.$router.push('/invoice-apply/approve/table')
          })
        })
      } else {
        this.$alert('必须填写驳回原因', '提示', {
          type: 'error',
        })
      }
    },
    financeAutoApprove () {
      this.showSplitView = true
    },
    // 拆票
    handleTicketSplit (data) {
      const params = {
        receipt_apply_id: this.$route.params.id,
        split_list: data.map(items => {
          return {
            notice_number: '',
            ticket_json: items.map(item => {
              return {
                spec: item.spec, // 规格
                unit: item.unit, // 单位
                quantity: item.quantity, // 数量，未填写请传 0
                invoice_name_id: item.invoice_name_id, // 开票名称 id
                no_tax_amount: item.no_tax_amount, // 未税金额
                with_tax_amount: item.with_tax_amount, // 含税金额
                tax_amount: item.tax_amount, // 税额
                tax_rate: item.tax_rate // 税率，取数据库开票名称的配置值
              }
            })
          }
        })
      }
      request.common('createReceiptSplitData', params).then(res => {
        this.$confirm('拆票成功，是否前往查看？', '提示', {type: 'warning'}).then(() => {
          this.$router.push('/invoice-apply/split/table?receipt_apply_id=' + this.$route.params.id)
        }).catch(() => {
          this.$router.back()
        })
      })
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.buttons {
  float: right;
  padding: 0 30px 30px 0;
}

// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceApplyApprove/InvoiceFinanceApproveForm.vue